import { Component, Input } from '@angular/core';
import { StateQuery } from '../../../store/state.store';

@Component({
	selector: 'lomas-student-toolbar',
	templateUrl: './student-toolbar.component.html',
	styleUrls: ['./student-toolbar.component.scss']
})
export class StudentToolbarComponent {
	@Input() title: string;

	constructor(private stateQuery: StateQuery) {}

	toggleSideNav = () => this.stateQuery.openSideNav();
}